export default function NoDataFound({ searchTerm }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="mb-6">
        <svg 
          className="w-25 h-25 text-gray-400"
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" stroke="currentColor" fill="#F9FAFB"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor"/>
        </svg>
      </div>
      
      <div className="text-center">
        {searchTerm ? (
          <>
            <h3 className="text-lg font-semibold text-gray-700 mb-1">
              No result found
            </h3>
            <p className="text-md text-gray-500">
              for search term '{searchTerm}'
            </p>
          </>
        ) : (
          <h3 className="text-lg font-semibold text-gray-700">
            No Subscribers Yet
          </h3>
        )}
      </div>
    </div>
  );
}